import React, { useState } from 'react';
import { Check, Code2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';

export const EmbedCodeDialog = ({ open, onOpenChange, embedUrl, embedCode, previewTitle, previewHeight = 380 }) => {
  const [copied, setCopied] = useState(false);

  const copyEmbed = async () => {
    try {
      await navigator.clipboard.writeText(embedCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch { /* clipboard unavailable */ }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-gray-900 border-white/10 text-white max-w-2xl" data-testid="embed-code-dialog">
        <DialogHeader>
          <DialogTitle>Embed on any website</DialogTitle>
          <DialogDescription className="text-gray-400">
            Copy the snippet below and paste it into any website or blog (WordPress, Wix, plain HTML…).
          </DialogDescription>
        </DialogHeader>
        <textarea
          readOnly
          value={embedCode}
          rows={4}
          onFocus={(e) => e.target.select()}
          className="w-full bg-black/40 border border-white/10 text-emerald-200 font-mono text-xs rounded-lg px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-red-500 resize-none"
          data-testid="embed-code-textarea"
        />
        <div className="flex items-center justify-between gap-3">
          <Button onClick={copyEmbed} className="bg-red-600 hover:bg-red-500" data-testid="embed-copy-btn">
            {copied ? <Check className="h-4 w-4 mr-1.5 text-emerald-300" /> : <Code2 className="h-4 w-4 mr-1.5" />}
            {copied ? 'Copied!' : 'Copy Embed Code'}
          </Button>
          <a
            href={embedUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-400 hover:text-white transition-colors"
            data-testid="embed-preview-link"
          >
            Preview card →
          </a>
        </div>
        <div className="rounded-xl overflow-hidden border border-white/10">
          <iframe
            src={embedUrl}
            title={previewTitle}
            style={{ height: previewHeight }}
            className="w-full border-0"
            loading="lazy"
            data-testid="embed-preview-iframe"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EmbedCodeDialog;
